// src/pages/About.js
import React from "react";
import "../App.css"; // Import necessary styles
import "../styles/AboutPage.css"; // Add this import

const About = () => {
  return (
    <div className="aboutpage-root">
      <div className="aboutpage-container">
      <h1 className="aboutpage-heading aboutpage-heading-visible">About ULJAAPP</h1>
        <p className="aboutpage-paragraph">
          <span className="aboutpage-glawhub">
            <strong>ULJAAPP</strong> 
          </span>{" "}
          is your trusted companion in the legal world. Whether you're a citizen seeking legal clarity or a legal practitioner enhancing your expertise, our platform bridges the gap between law and life—because justice belongs to everyone.
        </p>

        <h2 className="aboutpage-section-title">Our Mission</h2>
        <p className="aboutpage-paragraph">
          At <span className="aboutpage-glawhub">ULJAAPP</span>, our mission is to empower individuals and professionals with legal awareness and easy access to actionable knowledge. We believe that understanding the law shouldn't require a law degree. From learning your rights to drafting legal complaints, we’re here to support every step of the journey.
        </p>

        <h2 className="aboutpage-section-title">What We Offer</h2>
        <ul className="aboutpage-list">
          <li>
            🔍 <strong className="aboutpage-glawhub">Find Your Solutions:</strong> Get personalized legal insights based on your location and case type.
          </li>
          <li>
            📝 <strong className="aboutpage-glawhub">Create Drafts:</strong> Seamlessly draft legal documents, complaints, or petitions using our draft creation tool. 
          </li>
          <li>
            ✍️ <strong className="aboutpage-glawhub">Contribute:</strong> Share your legal knowledge, raise awareness, and help others to learn.
          </li>
          <li>
            📚 <strong className="aboutpage-glawhub">Learn the Law:</strong> Access structured guides, case studies, and step-by-step legal procedures.
          </li>
          <li>
            🤖 <strong className="aboutpage-glawhub">Smart Assistance:</strong> Use smart tools to draft complaints, understand legal rights, and discover practical solutions.
          </li>
          
        </ul>

        <h2 className="aboutpage-section-title">Why ULJAAPP?</h2>
        <p className="aboutpage-paragraph">
          We go beyond just providing information. We create a space where learning meets action. With a blend of expert insights and smart tools, we’re redefining how people interact with the law—making it more approachable, relevant, and human.
        </p>

        <div className="aboutpage-contact">
          <div className="aboutpage-contact-title">Contact Us</div>
          <ul className="aboutpage-contact-list">
            <li>
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M2 4.5A2.5 2.5 0 0 1 4.5 2h15A2.5 2.5 0 0 1 22 4.5v15a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 19.5v-15Zm2.75.75 7.25 6.5 7.25-6.5" stroke="#00bfae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M21.25 6.25 12 13.75 2.75 6.25" stroke="#00bfae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              <span>Email: <span className="aboutpage-glawhub">support.uljaapp@atozasindia.in</span></span>
            </li>
            <li>
              <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M12 2C7.03 2 3 6.03 3 11c0 5.25 7.05 10.45 8.13 11.23a1 1 0 0 0 1.13 0C13.95 21.45 21 16.25 21 11c0-4.97-4.03-9-9-9Zm0 17.88C9.09 17.09 5 13.92 5 11c0-3.87 3.13-7 7-7s7 3.13 7 7c0 2.92-4.09 6.09-7 8.88Z" fill="#00bfae"/><circle cx="12" cy="10" r="3" fill="#1976d2"/></svg>
              <span>
                Address: <span className="aboutpage-glawhub">ATOZ AUTOMATION SOLUTIONS PRIVATE LIMITED, F-18, PH VI AYA NAGAR EXTN. , NEW DELHI, India - 110047.</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    //
  );
};

export default About;
